import { serializeQS as serialize } from '@conversed/shared/src/helpers/serialize';
import axios, { type AxiosInstance } from 'axios';

import { API_ENDPOINT } from '../../constants/env';
import { DataKeys } from '../../constants/login';

export const axiosAuth = (): AxiosInstance => {
  const headers = {
    'Content-Type': 'application/x-www-form-urlencoded',
    'user-company': 'portal',
  };

  return axios.create({
    baseURL: API_ENDPOINT,
    headers,
    paramsSerializer: {
      serialize,
    },
  });
};

export const axiosDefault = (): AxiosInstance => {
  const company = localStorage.getItem(DataKeys.SELECTED_COMPANY_DATA_KEY);
  const token = localStorage.getItem(DataKeys.ACCESS_TOKEN_DATA_KEY);
  if (!token) {
    return axios.create({
      baseURL: API_ENDPOINT,
      headers: {
        'user-company': company ?? 'portal',
      },
      paramsSerializer: {
        serialize,
      },
    });
  }

  const headers = {
    common: {
      Authorization: `Bearer ${token}`,
      'user-company': company ?? 'portal',
    },
  };

  return axios.create({
    baseURL: API_ENDPOINT,
    headers,
    paramsSerializer: {
      serialize,
    },
  });
};
